// Format date based on user preference
export const formatDate = (dateString, format = 'readable') => {
  if (!dateString) return 'N/A';
  
  try {
    // Parse as local date to avoid timezone shifts
    const [year, month, day] = dateString.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    
    if (format === 'iso') {
      // Format: 2025-10-17
      return dateString;
    } else {
      // Format: Oct 17th 2025
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      const formatted = date.toLocaleDateString('en-US', options);
      
      // Add ordinal suffix (st, nd, rd, th)
      const dayNum = date.getDate();
      const suffix = getOrdinalSuffix(dayNum);
      
      return formatted.replace(dayNum.toString(), `${dayNum}${suffix}`);
    }
  } catch (error) {
    return dateString;
  }
};

// Format date with day of week (e.g., "Mon, Oct 17th 2025")
export const formatDateWithDay = (dateString, format = 'readable') => {
  if (!dateString) return 'N/A';
  
  try {
    const [year, month, day] = dateString.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const dayName = dayNames[date.getDay()];
    
    const formatted = formatDate(dateString, format);
    return `${dayName}, ${formatted}`;
  } catch (error) {
    return dateString;
  }
};

// Format time based on user preference
export const formatTime = (timeString, format = '12h') => {
  if (!timeString) return 'N/A';
  
  try {
    const [hours, minutes] = timeString.split(':').map(Number);
    
    if (format === '24h') {
      // Format: 23:00
      return timeString;
    } else {
      // Format: 11pm
      const period = hours >= 12 ? 'pm' : 'am';
      const displayHour = hours % 12 || 12;
      return `${displayHour}${minutes !== 0 ? ':' + String(minutes).padStart(2, '0') : ''}${period}`;
    }
  } catch (error) {
    return timeString;
  }
};

// Get ordinal suffix for day (1st, 2nd, 3rd, 4th, etc.)
const getOrdinalSuffix = (day) => {
  if (day > 3 && day < 21) return 'th';
  switch (day % 10) {
    case 1: return 'st';
    case 2: return 'nd';
    case 3: return 'rd';
    default: return 'th';
  }
};